import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

//
import moment from "moment";

//
import useSort from "../../hooks/useSort";
import useCheckPlan from "../../hooks/useCheckPlan";

//
import Moment from "react-moment";
import { useTable, useSortBy } from "react-table";
import {
  Card,
  InputGroup,
  FormControl,
  Badge,
  Button,
  Spinner,
} from "react-bootstrap";

//
import { iconImage } from "../../redux/features/coins/actions";
import { showPlanModal } from "../../redux/features/plan/slice";
import { getAlertHistory, getAlertHistoryExcel } from "../../redux/features/coins/actions";

//
import ImageBox from "../../components/general/ImageBox";
import PageHeader from "../../components/general/PageHeader";
import BoxLoading from "../../components/general/BoxLoading";
import Pagination from "../../components/general/Pagination";
import FilterDropdown from "../../components/general/FilterDropdown";
import MobileAlertList from "../../components/alert-history/MobileAlertList";
import NothingToShow from "../../components/general/NothingToShow";
import ReactTable from "../../components/general/ReactTable";
import ColumnVisibility from "../../components/general/ColumnVisibility";

//
import { alertHistoryTimeFilter } from "../../constances";

function AlertHistory({ windowSize, showPlanModal }) {
  const [checkPlan] = useCheckPlan();
  const [sort, updateSort] = useSort();

  const [searchBoxStatus, setSearchBoxStatus] = useState(false);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);

  const [activeTimeFilter, setActiveTimeFilter] = useState({
    name: "Last week",
    value: 7,
  });

  const [alerts, setAlerts] = useState({
    data: [],
    lastPage: 1,
    currentPage: 1,
    from: 1,
    total: 1,
  });

  const filters = [
    {
      name: "All Status",
      value: "all",
    },
    {
      name: "Pending",
      value: "pending",
    },
    {
      name: "Closed",
      value: "closed",
    },
  ];

  const [activeFilter, setActiveFilter] = useState({
    name: "All Status",
    value: "all",
  });

  /**
   * Get Alerts
   */
  const get_alerts = async (page) => {
    // start loading
    setLoading(true);

    // set variables
    let url = new URLSearchParams();
    url.set("page", page);
    url.set("daysFilter", activeTimeFilter.value);
    if (sort.key) {
      url.set("sortColumn", sort.key);
      url.set("sort", sort.type);
    }
    if (search) url.set("search", search);
    url.set("status", activeFilter.value);

    await getAlertHistory(url).then((res) => {
      if (res) {
        setAlerts({
          data: res.signals,
          lastPage: res.lastPage,
          currentPage: res.currentPage,
          total: res.total,
        });
      }
    });

    setLoading(false);
  };

  /**
   * Get Alerts Excel File
   */
  const get_alerts_excel = async () => {
    // start loading
    setExportLoading(true);

    // set variables
    let url = new URLSearchParams();
    const end_date = moment().format("YYYY-MM-DD");
    const start_date = moment()
      .subtract(activeTimeFilter.value - 1, "d")
      .format("YYYY-MM-DD");
    url.set("end_date", end_date);
    url.set("start_date", start_date);
    url.set("status", activeFilter.value);

    await getAlertHistoryExcel(url)

    setExportLoading(false);
  };

  // useEffect(() => {
  //   if (!checkPlan()) {
  //     showPlanModal({ show: true, step: "choose-plan", type:"plan" });
  //   }

  //   // eslint-disable-next-line
  // }, []);

  /**
   * Get coin events every time active filter change
   */
  useEffect(() => {
    get_alerts(1);
  }, [activeFilter, search, activeTimeFilter, sort]);
  // end::filters

  // begim::table
  const data = alerts.data;

  const columns = React.useMemo(
    () => [
      {
        Header: "Coin",
        accessor: "symbol", // accessor is the "key" in the data
        Cell: (cellProps) => {
          let symbol = cellProps.value;

          return (
            <div className="d-flex align-items-center">
              <ImageBox src={iconImage(symbol.split("/")[0])} alt={symbol} />
              <Link
                to={`/app/coin-detail/${symbol.split("/")[0]}`}
                className="fw-bolder text-black"
              >
                {symbol}
              </Link>
            </div>
          );
        },
      },
      {
        Header: "Enter Price",
        accessor: "entry_price", // accessor is the "key" in the data
        Cell: (cellProps) => {
          let value = cellProps.value;
          let base_name = cellProps.row.original.base_name;

          return (
            <small className="m-0 text-dark">
              {Number(value)
                .toFixed(base_name === "Bitcoin" ? 2 : 8)
                .replace(/\.?0+$/, "")}
            </small>
          );
        },
      },
      {
        Header: "Targets",
        accessor: "target", // accessor is the "key" in the data
        Cell: (cellProps) => {
          let base_name = cellProps.row.original.base_name;

          let target_1 = cellProps.value;
          let target_2 = cellProps.row.original.target_2;
          let target_3 = cellProps.row.original.target_3;

          let target_1_hit_at = cellProps.row.original.target_1_hit_at;
          let target_2_hit_at = cellProps.row.original.target_2_hit_at;
          let target_3_hit_at = cellProps.row.original.target_3_hit_at;

          return (
            <div className="target">
              <small>
                {target_1_hit_at ? (
                  <i className="las la-check-circle text-success"></i>
                ) : (
                  <i className="lar la-times-circle text-danger"></i>
                )}
                <span className="fw-extra-bolder">T1.</span>{" "}
                {Number(target_1)
                  .toFixed(base_name === "Bitcoin" ? 2 : 8)
                  .replace(/\.?0+$/, "")}
              </small>
              <small>
                {target_2_hit_at ? (
                  <i className="las la-check-circle text-success"></i>
                ) : (
                  <i className="lar la-times-circle text-danger"></i>
                )}
                <span className="fw-extra-bolder">T2.</span>{" "}
                {Number(target_2)
                  .toFixed(base_name === "Bitcoin" ? 2 : 8)
                  .replace(/\.?0+$/, "")}
              </small>
              <small className="m-0">
                {target_3_hit_at ? (
                  <i className="las la-check-circle text-success"></i>
                ) : (
                  <i className="lar la-times-circle text-danger"></i>
                )}
                <span className="fw-extra-bolder">T3.</span>{" "}
                {Number(target_3)
                  .toFixed(base_name === "Bitcoin" ? 2 : 8)
                  .replace(/\.?0+$/, "")}
              </small>
            </div>
          );
        },
      },
      {
        Header: "Stoploss",
        accessor: "stop_loss", // accessor is the "key" in the data
        Cell: (cellProps) => {
          let base_name = cellProps.row.original.base_name;
          let value = cellProps.value;

          return (
            <small>
              {Number(value)
                .toFixed(base_name === "Bitcoin" ? 2 : 8)
                .replace(/\.?0+$/, "")}
            </small>
          );
        },
      },
      {
        Header: "Action",
        accessor: "action", // accessor is the "key" in the data
        Cell: (cellProps) => {
          let value = cellProps.value;

          return (
            <small
              className={`fw-bolder ${
                value == "BUY" ? "text-success" : "text-danger"
              }`}
            >
              {value}
            </small>
          );
        },
      },
      {
        Header: "Win Status",
        accessor: "win_status", // accessor is the "key" in the data
        Cell: (cellProps) => {
          let value = cellProps.value;

          const convertStatus = () => {
            if (value === "won") return "Won";
            if (value === "stopLoss") return "Stoploss";
            if (value === "trendChanged") return "Trend Changed";
          };

          const statusColor = () => {
            if (value === "won") return "success";
            if (value === "stopLoss") return "danger";
            if (value === "trendChanged") return "muted";
          };

          return (
            <small className={`fw-bolder text-${statusColor()}`}>
              {convertStatus()}
            </small>
          );
        },
      },
      {
        Header: "Target Profit",
        accessor: "max_profit_amount", // accessor is the "key" in the data
        Cell: (cellProps) => {
          let value = cellProps.value;
          return <small className="m-0 text-dark">{value || 0} %</small>;
        },
      },
      {
        Header: "Potential Profit",
        accessor: "max_market_profit", // accessor is the "key" in the data
        Cell: (cellProps) => {
          let value = cellProps.value;
          return <small className="m-0 text-dark">{value || 0} %</small>;
        },
      },
      {
        Header: "Highest/Lowest Price",
        accessor: "high_market_price", // accessor is the "key" in the data
        Cell: (cellProps) => {
          let base_name = cellProps.row.original.base_name;
          let action = cellProps.row.original.action;
          let high_market_price = cellProps.value;
          let low_market_price = cellProps.row.original.low_market_price;
          let value = action === "BUY" ? high_market_price : low_market_price;

          return (
            <small className="m-0 text-dark">
              {Number(value)
                .toFixed(base_name === "Bitcoin" ? 2 : 8)
                .replace(/\.?0+$/, "")}
            </small>
          );
        },
      },
      {
        Header: "Win Rate",
        accessor: "success_rate", // accessor is the "key" in the data
        Cell: (cellProps) => {
          let value = cellProps.value;
          return (
            <small className="m-0 text-dark">
              {Number(value).toFixed(2)} %
            </small>
          );
        },
      },
      {
        Header: "Date open (UTC)",
        accessor: "created_at", // accessor is the "key" in the data
        Cell: (cellProps) => {
          let value = cellProps.value;

          return (
            <small className="date">
              <span className="fw-bolder">
                <Moment utc format="MMM DD, YYYY, ">
                  {value}
                </Moment>
              </span>
              <span>
                <Moment utc format="hh:mm">
                  {value}
                </Moment>
              </span>
            </small>
          );
        },
      },
      {
        Header: "Status",
        accessor: "status", // accessor is the "key" in the data
        Cell: (cellProps) => {
          let value = cellProps.value;

          return (
            <Badge bg={value === "closed" ? "dark" : "secondary"}>
              {value === "closed" ? "Closed" : "Pending"}
            </Badge>
          );
        },
      },
    ],

    []
  );

  const initialState = { hiddenColumns: ["success_rate", "max_market_profit"] };

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    allColumns,
  } = useTable({ columns, data, initialState }, useSortBy);
  // end::table

  return (
    <div id="alert-history">
      <PageHeader
        title="Last Alerts"
        subject="Showing history alert of all crypto coins"
      >
        <FilterDropdown
          filters={alertHistoryTimeFilter}
          activeFilter={activeTimeFilter}
          action={(item) => setActiveTimeFilter(item)}
          title="Date"
          icon="las la-calendar-minus"
        />
        {!!alerts.data.length && (
          <Button
            variant="info"
            type="button"
            size="lg"
            disabled={exportLoading}
            onClick={() => get_alerts_excel()}
          >
            Export
            {exportLoading && (
              <div className="spinner-holder">
                <Spinner animation="border" variant="white" size="sm" />
              </div>
            )}
          </Button>
        )}
      </PageHeader>

      <Card className="gutter-b">
        {searchBoxStatus && (
          <div
            className="click-box"
            onClick={() => setSearchBoxStatus(false)}
          ></div>
        )}
        <Card.Header
          className={[
            "with-dropdown search",
            `${searchBoxStatus ? "active" : ""}`,
          ]}
        >
          <span>{alerts.total} Alerts</span>

          <div className="d-flex">
            <InputGroup onClick={() => setSearchBoxStatus(true)}>
              <InputGroup.Text>
                <i className="las la-search"></i>
              </InputGroup.Text>
              <FormControl
                placeholder="Search crypto"
                className="ps-0"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </InputGroup>

            <FilterDropdown
              title={windowSize > 768 && "Status"}
              filters={filters}
              activeFilter={activeFilter}
              action={(item) => setActiveFilter(item)}
            />

            {windowSize > 576 && (
              <ColumnVisibility
                title={windowSize > 768 && "Column Visibility"}
                icon={windowSize < 768 && "lar la-list-alt"}
                allColumns={allColumns}
              />
            )}
          </div>
        </Card.Header>

        <Card.Body className={windowSize > 576 ? "table-padding" : "p-0"}>
          {alerts.data.length ? (
            <>
              {windowSize > 576 ? (
                <ReactTable
                  rows={rows}
                  sort
                  bodySpace
                  apiSort={updateSort}
                  prepareRow={prepareRow}
                  headerGroups={headerGroups}
                  getTableProps={getTableProps}
                  getTableBodyProps={getTableBodyProps}
                />
              ) : (
                <MobileAlertList items={alerts.data} />
              )}
            </>
          ) : (
            <NothingToShow text={loading ? "Loading..." : "Nothing to show"} />
          )}

          {loading && <BoxLoading />}
        </Card.Body>

        {alerts.lastPage > 1 && (
          <Card.Footer>
            <small>
              Showing
              <span className="fw-bolder mx-1">25</span>of
              <span className="fw-bolder mx-1">{alerts.total}</span>alerts
            </small>
            <Pagination
              currentPage={alerts.currentPage - 1}
              lastPage={alerts.lastPage}
              changePage={(page) => get_alerts(page.selected + 1)}
            />
          </Card.Footer>
        )}
      </Card>
    </div>
  );
}

AlertHistory.propTypes = {
  windowSize: PropTypes.number.isRequired,
  showPlanModal: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  showPlanModal,
};

const mapStateToProps = (state) => ({
  windowSize: state.themeReducer.windowSize,
});

export default connect(mapStateToProps, mapDispatchToProps)(AlertHistory);
